module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAe0lEQVR42u3aQQ2AQBAEwVWBGNRgAjuowcD5IRmSszH1aAP17kkyzQ0AAAAAAAAAAAAAAOUA81xpCgAAAAAAAAAAAAAAAAB23zrSFAAAAAAAAAAAAAAAAADszvtNUwAAAAAAAAAAAAAAAAAAwCgJAAAAAAAAAAAAAEBdP6WprBuuxmm4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Gabon.png
// module id = cyJX
// module chunks = 0 62 63